module.exports = __webpack_public_path__ + "img/fm.5f418bd7.svg";